import Video from "../assets/video.mp4";
import Video2 from "../assets/video2.mp4";

export const Data = [
  {
    id: 1,
    image:
      "https://images.unsplash.com/photo-1665686308827-eb62e4f6604d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Business Law",
    category: "business Law",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video2,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 2,
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Branding",
    category: "marketing",
    timeFrame: "20min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 3,
    image:
      "https://images.unsplash.com/photo-1674574124345-02c525664b65?ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "General Health",
    category: "health & fitness",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 4,
    image:
      "https://images.unsplash.com/photo-1665686308827-eb62e4f6604d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Business Law",
    category: "business Law",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },

  {
    id: 5,
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Branding",
    category: "marketing",
    timeFrame: "20min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 6,
    image:
      "https://images.unsplash.com/photo-1674574124345-02c525664b65?ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "General Health",
    category: "health & fitness",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 7,
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Branding",
    category: "marketing",
    timeFrame: "20min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 8,
    image:
      "https://images.unsplash.com/photo-1665686308827-eb62e4f6604d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Business Law",
    category: "business law",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 9,
    image:
      "https://images.unsplash.com/photo-1674574124345-02c525664b65?ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "General Health",
    category: "health & fitness",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
  {
    id: 10,
    image:
      "https://images.unsplash.com/photo-1665686308827-eb62e4f6604d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1770&q=80",
    title: "Business Law",
    category: "Business Law",
    timeFrame: "30min",
    chapter: "Chapter 1",
    value: 67,
    courses: [
      {
        title: "Business Law",
        chapter: "Chapter 1",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 1, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 2",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 2, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
      {
        title: "Business Law",
        chapter: "Chapter 3",
        timeFrame: "30min",
        videoUrl: Video,
        description:
          "Chapter 3, Business law, also known as commercial law or corporate law, encompasses a broad range of legal principles and regulations that govern various aspects of business transactions and operations. It provides a framework for businesses to interact with one another, their employees, customers, and the general public, ensuring fairness, accountability, and legal compliance.",
      },
    ],
  },
];
